/**
 * Asserts that all provided ID values are loaded (non-falsy and not placeholder defaults).
 * Throws if any value is 0, empty string, undefined, or 'unknown'.
 */
export function guardId(...ids: (string | number | undefined)[]): void {
    for (const id of ids) {
        if (!id || id === 'unknown') {
            throw new Error(`API call attempted with unloaded ID: ${id}`);
        }
    }
}
